import { permissions } from '../constants/permissions';

const userPermissions = user => user && user.permissions;
const userRole = user => user && user.role.id;
const STCs = user => user && user.serviceTechnologyCenters;
const userId = user => user && user.id;

const hasSTC = user => user && STCs(user) && STCs(user).find(stc => !stc.connectedToSAP);
// const hasSTCConnectedToSAP = user => user && STCs(user) && STCs(user).find(stc => stc.connectedToSAP);
const getProperReportPermission = reportLevel => `LEVEL_${reportLevel}_REPORT_APPROVAL`;
const getProperReopenReportPermission = reportLevel => `LEVEL_${reportLevel}_REPORT_REOPEN`;
const getProperReleasePermission = reportLevel => `LEVEL_${reportLevel}_RELEASE_FOR_INVESTIGATION`;

export const userHasPermission = (user, permission) => user && userPermissions(user) && userPermissions(user).includes(permission);
export const userHasRole = (user, role) => user && userRole(user) && userRole(user) === role;
export const userHasRoles = (user, roles) => user && userRole(user) && roles.some(role => userHasRole(user, role));
export const userHasId = (user, ids) => user && (Array.isArray(ids) ? ids.includes(userId(user)) : userId(user) === ids);
export const userHasPermissionWithId = (user, permission, ids) => userHasId(user, ids) && userHasPermission(user, permission);
export const userHasReportPermissionWithId = (user, reportLevel, ids) => userHasId(user, ids) && userHasPermission(user, getProperReportPermission(reportLevel));
export const userHasReopenReportPermission = (user, reportLevel) => userHasPermission(user, getProperReopenReportPermission(reportLevel));
export const userHasReleasePermission = (user, reportLevel) => userHasPermission(user, getProperReleasePermission(reportLevel));
export const userIsActionRequester = (user, actionRequest) => user && actionRequest && user.id === actionRequest.requesterId;
export const canAddJob = user => user && hasSTC(user) && userHasPermission(user, permissions.CREATE_JOB);
export const canImportJobFromSAP = user => user && userHasPermission(user, permissions.IMPORT_JOB_FROM_SAP);



// WEBPACK FOOTER //
// ./src/utils/permissions.js